export enum LabelType {
    IMAGE_RECOGNITION = 'IMAGE RECOGNITION',
    POINT = 'POINT',
    RECT = 'RECT',
    POLYGON = 'POLYGON',
    POLYLINE = 'POLYLINE',
    LINE = 'LINE',
    TAG = 'TAG',
    AUDIO = 'AUDIO'

}